import { render, staticRenderFns } from "./ToolPeripheralChart.vue?vue&type=template&id=8df110e4"
import script from "./ToolPeripheralChart.vue?vue&type=script&lang=js"
export * from "./ToolPeripheralChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports